module.exports = __webpack_public_path__ + "img/close_icon.f8544dbd.svg";